export const DEALER_SELECTIONS = {
    MANUAL: 'manual',
    AUTO: 'automatic'
}

export const DEALER_SELECTIONS_LABELS = {
    [DEALER_SELECTIONS.MANUAL]: 'Chcę wskazać serwis samodzielnie',
    [DEALER_SELECTIONS.AUTO]: 'Chcę, aby przypisano serwis kas fiskalnych automatycznie'
}